// react
import { connect } from "react-redux";
import CompareIndicator from "../header/IndicatorCompare";
import Indicator from "../header/Indicator";
import IndicatorAccount from "../header/IndicatorAccount";
import { Heart20Svg,  } from "../../svg";

function FooterMobileSticky(props) {
  const {  wishlist, } = props;
  return (
    <div className="sticky-footer-bar">
      <div className="bar-item">
        <IndicatorAccount mobile={true} index={2} />
        <div>Account</div>
      </div>
      <div className="bar-item">
        <CompareIndicator />
        <div>Compare</div>
      </div>
      <div className="bar-item">
        <Indicator url="/shop/wishlist" value={wishlist} name1={"Wishlist"} icon={<Heart20Svg />} />
        <div>Wishlist</div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  wishlist: state.wishlist.length,
  compare: state.compare.length,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(FooterMobileSticky);
